var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from "@reduxjs/toolkit";
var initialState = {
    venue: {
        buttonText: "",
        id: "",
        name: "",
        description: "",
        isPrivate: false,
        address: {
            city: "",
            label: "",
            state: "",
            county: "",
            street: "",
            country: "",
            district: "",
            postalCode: "",
            countryCode: "",
            houseNumber: "",
            subdistrict: "",
        },
        location: {
            lat: 0,
            lng: 0,
        },
        venueCategory: "",
        modified: "",
        created: "",
        state: "",
        chipStyle: {},
        isDraft: false,
        draftStatus: "",
    },
};
var slice = createSlice({
    name: "venue",
    initialState: initialState,
    reducers: {
        setVenue: function (state, _a) {
            var payload = _a.payload;
            return (__assign(__assign({}, state), { venue: payload }));
        },
        reset: function () { return initialState; },
    },
});
export var setVenue = (_a = slice.actions, _a.setVenue), reset = _a.reset;
export default slice.reducer;
